import { GetFormaGiuridicaCerQuery } from '../../_graphql/generated';

export type FormaGiuridicaCerState = {
  loading: boolean;
  lista: GetFormaGiuridicaCerQuery['anagrafica_forma_giuridica_cer'];
  failure: any;
};

export const initialFormaGiuridicaCerState: FormaGiuridicaCerState = {
  loading: false,
  lista: [],
  failure: '',
};
